import React from 'react';
import MKBox from 'components/MKBox';
import MKTypography from 'components/MKTypography';

function PrivacyPolicy() {
  return (
    <MKBox component="section" py={{ xs: 3, lg: 0 }}>
      <MKBox px={{ xs: 2, sm: 3 }} py={{ xs: 2, sm: 6 }}>
        <MKTypography variant="h5" sx={{ fontWeight: 'normal', mb: 1 }}>
          POLÍTICA DE TRATAMIENTO DE DATOS PERSONALES
        </MKTypography>

        <MKTypography variant="h6" sx={{ fontWeight: 'normal', mb: 1 }}>
          1. Responsable del tratamiento de datos
        </MKTypography>
        <MKTypography variant="body2" sx={{ mb: 3 }}>
          DEV-CODES SAS, con domicilio en Ciudadela Complex, Km 8 Vía LLanogrande- edificio 57/58
          piso 2 y correo electrónico{' '}
          <a href="mailto:comercial@dev-codes.com">comercial@dev-codes.com</a>, es el responsable
          del tratamiento de los datos personales proporcionados a través del formulario de contacto
          en el sitio web{' '}
          <a href="https://dev-codes.com/" target="_blank" rel="noopener noreferrer">
            https://dev-codes.com/
          </a>
          .
        </MKTypography>

        <MKTypography variant="h6" sx={{ fontWeight: 'normal', mb: 1 }}>
          2. Datos personales recopilados
        </MKTypography>
        <MKTypography variant="body2" sx={{ mb: 3 }}>
          Al completar el formulario de contacto, recopilamos la siguiente información personal:
          Nombre completo, correo electrónico, número de celular y mensaje. Además, el sitio web
          puede recopilar datos de navegación mediante cookies y herramientas de análisis.
        </MKTypography>

        <MKTypography variant="h6" sx={{ fontWeight: 'normal', mb: 1 }}>
          3. Finalidad del tratamiento de datos
        </MKTypography>
        <MKTypography variant="body2" sx={{ mb: 3 }}>
          Los datos personales recopilados serán utilizados exclusivamente para:
          <ul>
            <li>Responder consultas y solicitudes de información.</li>
            <li>Brindar soporte o asesoría sobre nuestros servicios.</li>
            <li>Mantener comunicación en relación con la solicitud realizada.</li>
            <li>
              Analizar el tráfico del sitio web y mejorar la experiencia del usuario (en el caso de
              cookies).
            </li>
          </ul>
        </MKTypography>

        <MKTypography variant="h6" sx={{ fontWeight: 'normal', mb: 1 }}>
          4. Uso de cookies
        </MKTypography>
        <MKTypography variant="body2" sx={{ mb: 3 }}>
          El sitio web{' '}
          <a href="https://dev-codes.com/" target="_blank" rel="noopener noreferrer">
            https://dev-codes.com/
          </a>{' '}
          utiliza cookies con las siguientes finalidades:
          <ul>
            <li>
              <b>Cookies esenciales:</b> Garantizan el correcto funcionamiento del sitio web.
            </li>
            <li>
              <b>Cookies analíticas:</b> Recopilan información sobre el comportamiento de los
              usuarios para mejorar el sitio web.
            </li>
            <li>
              <b>Cookies de terceros:</b> Herramientas como Google Analytics pueden recopilar datos
              anónimos sobre la interacción de los usuarios.
            </li>
          </ul>
          Los usuarios pueden gestionar sus preferencias de cookies a través de la configuración del
          navegador.
        </MKTypography>

        <MKTypography variant="h6" sx={{ fontWeight: 'normal', mb: 1 }}>
          5. Base legal para el tratamiento
        </MKTypography>
        <MKTypography variant="body2" sx={{ mb: 3 }}>
          El tratamiento de datos personales se realiza con base en el consentimiento otorgado por
          el titular al enviar el formulario de contacto y aceptar el uso de cookies en el sitio
          web.
        </MKTypography>

        <MKTypography variant="h6" sx={{ fontWeight: 'normal', mb: 1 }}>
          6. Almacenamiento y seguridad
        </MKTypography>
        <MKTypography variant="body2" sx={{ mb: 3 }}>
          Los datos personales serán almacenados en servidores seguros y se implementarán medidas de
          seguridad adecuadas para protegerlos contra acceso no autorizado, pérdida o alteración.
        </MKTypography>

        <MKTypography variant="h6" sx={{ fontWeight: 'normal', mb: 1 }}>
          7. Derechos del titular de los datos (Habeas data)
        </MKTypography>
        <MKTypography variant="body2" sx={{ mb: 3 }}>
          Los titulares de los datos pueden ejercer los siguientes derechos:
          <ul>
            <li>Acceder, actualizar o rectificar sus datos personales.</li>
            <li>Solicitar la eliminación de sus datos cuando ya no sean necesarios.</li>
            <li>
              Revocar su consentimiento para el tratamiento de sus datos en cualquier momento.
            </li>
            <li>Gestionar las preferencias de cookies desde la configuración del navegador.</li>
          </ul>
          Para ejercer estos derechos, los usuarios pueden enviar una solicitud al correo
          electrónico <a href="mailto:comercial@dev-codes.com">comercial@dev-codes.com</a>.
        </MKTypography>

        <MKTypography variant="h6" sx={{ fontWeight: 'normal', mb: 1 }}>
          8. Compartición de datos con terceros
        </MKTypography>
        <MKTypography variant="body2" sx={{ mb: 3 }}>
          DEV-CODES SAS no compartirá, venderá ni divulgará los datos personales a terceros, salvo
          en los siguientes casos:
          <ul>
            <li>
              Cuando sea requerido por una autoridad competente en cumplimiento de normativas
              legales.
            </li>
            <li>
              Si es necesario para el cumplimiento de un contrato o servicio solicitado por el
              usuario.
            </li>
            <li>
              En el caso del uso de herramientas de análisis web (como Google Analytics), que pueden
              recopilar información anónima sobre la interacción del usuario.
            </li>
          </ul>
        </MKTypography>

        <MKTypography variant="h6" sx={{ fontWeight: 'normal', mb: 1 }}>
          9. Vigencia y modificación de la política
        </MKTypography>
        <MKTypography variant="body2" sx={{ mb: 3 }}>
          Esta política de tratamiento de datos entra en vigor a partir de su publicación y puede
          ser modificada en cualquier momento. Se recomienda revisar periódicamente esta sección
          para estar informado sobre cualquier actualización.
        </MKTypography>
      </MKBox>
    </MKBox>
  );
}

export default PrivacyPolicy;
